import { useState, useEffect, useCallback } from "react";
import SchrijfSoorten from "./SchrijfSoorten";
import BasismapBlok from "./BasismapBlok";
import DataOverzicht from "./DataOverzicht";
import DropboxSchakelaar from "./DropboxSchakelaar";
import BackupBlok from "./BackupBlok";
import PqcBlok from "./PqcBlok";
import ExportBlok from "./ExportBlok";
import DossierControle from "./DossierControle";
import VluchtrecorderBlok from "./VluchtrecorderBlok";
import LogboekBlok from "./LogboekBlok";
import OverBlok from "./OverBlok";
import CodeModelKeuze from "./CodeModelKeuze";
import VerslagInstelling from "./VerslagInstelling";
import MachineAdvies from "./MachineAdvies";
import ModelRollen from "./ModelRollen";
import CodeMeetset from "./CodeMeetset";
import PersonaBlok from "./PersonaBlok";
// From react-router rather than react-router-dom, for the same reason as
// MobileBottomNav: the dom package reaches its hooks through a subpath export
// that the Jest pinned by react-scripts 5 cannot resolve.
import { useNavigate } from "react-router";
import axios from "axios";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import GoogleConnection from "./GoogleConnection";
import NextcloudConnection from "./NextcloudConnection";
import McpServers from "./McpServers";
import { Switch } from "./ui/switch";
import PairedDevices from "./PairedDevices";
import Grenzen from "./Grenzen";
import Organisatie from "./Organisatie";
import { AbonnementBlok } from "../pages/BillingPage";
import { WinkelBlok } from "../pages/StorePage";
import { NetwerkBlok } from "../pages/NetworkPage";
import SpeaqIdPanel from "./SpeaqIdPanel";
import DirectConnection from "./DirectConnection";
import ConnectionRecord from "./ConnectionRecord";
import { Eye, EyeOff, ExternalLink, RefreshCw, Download, Key, Plus, Trash2, Cloud } from "lucide-react";
import { toast } from "sonner";
import { PROVIDERS } from "../lib/providers";
import { gegroepeerd } from "../lib/aanbieder-locatie";
import { useBranding } from "../contexts/BrandingContext";
import RoutingPolicyPanel from "./RoutingPolicyPanel";
import { API } from "@/lib/api";
import TaalSchakelaar from "./TaalSchakelaar";
import { useTaal } from "@/contexts/TaalContext";


// POST P (1 nov 2026): leeg. De persona staat in Merk; het tabblad Prompt is een vrij extra blok na de persona.
const DEFAULT_SYSTEM_PROMPT = "";

// I7: `tab` laat "Connectors beheren" in het plusmenu meteen op Verbindingen openen.
export default function SettingsDialog({ open, onOpenChange, onSave, tab = "provider" }) {
  const { t } = useTaal();
  const navigate = useNavigate();
  const [model, setModel] = useState("claude-sonnet-5");
  const [provider, setProvider] = useState("anthropic");
  const [ollamaHost, setOllamaHost] = useState("http://localhost:11434");
  // CC3 (24 okt): de eigen OpenAI-compatibele aanbieder.
  const [eigenAdres, setEigenAdres] = useState("");
  const [eigenLocatie, setEigenLocatie] = useState("");
  const [systemPrompt, setSystemPrompt] = useState(DEFAULT_SYSTEM_PROMPT);
  const [ollamaModels, setOllamaModels] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoadingOllama, setIsLoadingOllama] = useState(false);
  const [pullModelName, setPullModelName] = useState("");
  const [isPulling, setIsPulling] = useState(false);
  const [pullProgress, setPullProgress] = useState("");

  const [councilModels, setCouncilModels] = useState([]);
  const [councilMaxMembers, setCouncilMaxMembers] = useState(0);
  const [clawAllowedDomains, setClawAllowedDomains] = useState("");
  const [clawBlockedDomains, setClawBlockedDomains] = useState("");
  // Off until the server says otherwise. A screen that guesses "on" while the
  // answer is still in flight would show a label that is not true yet.
  const [webAccess, setWebAccess] = useState(false);
  // DE TABELWEG (R40). AAN als beginwaarde en niet uit, want de kolom is
  // NULL-is-aan: zou dit op `false` staan, dan flikkert de schakelaar bij het
  // openen van uit naar aan zodra het antwoord binnenkomt.
  const [tabelweg, setTabelweg] = useState(true);
  // R19: mag NovaMund een bewerkt document terugschrijven naar het bestand.
  //
  // BEGINT OP `false`, EN DAT IS DE OMGEKEERDE RICHTING VAN `tabelweg` HIERBOVEN.
  // Die begint op `true` omdat een bestaande functie niet mag flikkeren van uit
  // naar aan. Hier is het omgekeerde de eis: een scherm dat even "aan" toont
  // voordat de server antwoordt, zou schrijfrecht suggereren dat niemand heeft
  // gegeven. Standaard uit betekent ook standaard uit tijdens het laden.
  const [vaultWrite, setVaultWrite] = useState(false);
  // Leeg betekent "nooit gekozen", en dat is iets anders dan een gekozen 0.
  // Daarom een string en geen getal: een leeg tekstveld is de enige vorm
  // waarin "geen keuze" en "de waarde nul" niet op elkaar lijken. De standaard
  // die dan geldt komt van de server, want die bezit hem.
  const [temperature, setTemperature] = useState("");
  const [defaultTemperature, setDefaultTemperature] = useState(0);

  const [apiKeys, setApiKeys] = useState([]);
  const [newKeyValue, setNewKeyValue] = useState("");
  const [showNewKey, setShowNewKey] = useState(false);
  const [isAddingKey, setIsAddingKey] = useState(false);

  const { refreshBranding } = useBranding();
  const [brandName, setBrandName] = useState("");
  const [brandAccent, setBrandAccent] = useState("");
  const [brandLogo, setBrandLogo] = useState("");
  // F3b (Frank, 20 oktober 2026): een huisstijl per installatie, alleen een eigenaar
  // wijzigt hem. Zolang de rol onbekend is, wordt er niets gestuurd.
  const [brandMagWijzigen, setBrandMagWijzigen] = useState(false);
  // POST P: de rol bepaalt of het blok Persona er staat (een kijker ziet het niet).
  const [brandRol, setBrandRol] = useState("");

  const fetchBranding = async () => {
    try {
      const res = await axios.get(`${API}/branding`);
      setBrandName(res.data.app_name || "");
      setBrandAccent(res.data.accent_color || "");
      setBrandLogo(res.data.logo_data_uri || "");
    } catch {}
    try {
      const o = await axios.get(`${API}/organisatie`);
      setBrandMagWijzigen(o?.data?.mijn_rol === "eigenaar");
      setBrandRol(o?.data?.mijn_rol || "");
    } catch {
      setBrandMagWijzigen(false);
      setBrandRol("");
    }
  };

  const handleLogoFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 350 * 1024) {
      toast.error(t("Het logo moet kleiner zijn dan 350 KB"));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => setBrandLogo(reader.result);
    reader.readAsDataURL(file);
    e.target.value = "";
  };

  useEffect(() => {
    if (open) {
      fetchSettings();
      fetchApiKeys();
      fetchBranding();
    }
  }, [open]);

  // isChatProvider distinguishes the two reasons this list is wanted. When
  // Ollama is what you chat with, the list also decides which model is
  // selected and a failure is worth a toast. When it is only feeding the
  // council's member picker, it must do neither: changing the chat model or
  // complaining about Ollama being down would both be wrong for someone who
  // chats with Anthropic.
  const fetchOllamaModels = useCallback(async (isChatProvider = true) => {
    setIsLoadingOllama(true);
    try {
      const response = await axios.get(`${API}/ollama/models`);
      if (response.data.models?.length > 0) {
        setOllamaModels(response.data.models);
        // Functional update — avoids closing over `model`, which would make this
        // callback's identity change on every model switch and re-trigger the
        // effect below in a loop.
        if (isChatProvider) {
          setModel(prev => response.data.models.includes(prev) ? prev : response.data.models[0]);
        }
      } else if (response.data.error) {
        if (isChatProvider) toast.error(t("Kon geen verbinding maken met Ollama"));
        setOllamaModels([]);
      }
    } catch (error) {
      setOllamaModels([]);
    } finally {
      setIsLoadingOllama(false);
    }
  }, [t]);

  useEffect(() => {
    fetchOllamaModels(provider === "ollama");
  }, [provider, ollamaHost, fetchOllamaModels]);

  const fetchApiKeys = async () => {
    try {
      const response = await axios.get(`${API}/keys`);
      setApiKeys(response.data);
    } catch (error) {
      console.error("Error fetching API keys:", error);
    }
  };

  const handleAddKey = async () => {
    if (!newKeyValue.trim()) return;
    setIsAddingKey(true);
    try {
      await axios.post(`${API}/keys`, { provider, key_value: newKeyValue.trim(), label: `${provider} key` });
      toast.success(t("API-sleutel opgeslagen"));
      setNewKeyValue("");
      setShowNewKey(false);
      await fetchApiKeys();
    } catch (error) {
      toast.error(t("API-sleutel opslaan is mislukt"));
    } finally {
      setIsAddingKey(false);
    }
  };

  const handleDeleteKey = async (keyId) => {
    try {
      await axios.delete(`${API}/keys/${keyId}`);
      toast.success(t("API-sleutel verwijderd"));
      await fetchApiKeys();
    } catch (error) {
      toast.error(t("API-sleutel verwijderen is mislukt"));
    }
  };

  const fetchSettings = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${API}/settings`);
      if (response.data.model) setModel(response.data.model);
      if (response.data.provider) setProvider(response.data.provider);
      if (response.data.ollama_host) setOllamaHost(response.data.ollama_host);
      setEigenAdres(response.data.eigen_adres || "");
      setEigenLocatie(response.data.eigen_locatie || "");
      if (response.data.system_prompt) setSystemPrompt(response.data.system_prompt);
      if (response.data.council_ollama_models !== undefined) setCouncilModels(response.data.council_ollama_models);
      if (response.data.council_max_members) setCouncilMaxMembers(response.data.council_max_members);
      if (response.data.claw_allowed_domains !== undefined) setClawAllowedDomains(response.data.claw_allowed_domains);
      if (response.data.claw_blocked_domains !== undefined) setClawBlockedDomains(response.data.claw_blocked_domains);
      setWebAccess(Boolean(response.data.web_access));
      // Bewust geen `||`: dat zou een gekozen 0 in een leeg veld veranderen.
      setTemperature(response.data.temperature === null || response.data.temperature === undefined
        ? "" : String(response.data.temperature));
      if (response.data.default_temperature !== undefined) setDefaultTemperature(response.data.default_temperature);
      // ONTBREEKT HET VELD, DAN AAN. Een oudere server die dit niet stuurt mag
      // de schakelaar niet op uit zetten; dat zou een functie stil uitzetten.
      setTabelweg(response.data.tabelweg !== false);
      // `=== true` en niet `!== false`: een oudere server die dit veld niet
      // kent, mag geen schrijfrecht geven. `undefined` is hier UIT.
      setVaultWrite(response.data.vault_write === true);
    } catch (error) {
      console.error("Error fetching settings:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePullModel = async () => {
    if (!pullModelName.trim()) return;
    setIsPulling(true);
    setPullProgress("Starting download...");
    
    try {
      const response = await fetch(`${API}/ollama/pull`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ model_name: pullModelName.trim() })
      });

      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value);
        const lines = chunk.split("\n").filter(line => line.startsWith("data: "));

        for (const line of lines) {
          try {
            const data = JSON.parse(line.slice(6));
            if (data.error) {
              toast.error(data.error);
              break;
            }
            if (data.status === "complete") {
              toast.success(t("Model {m} is gedownload", { m: pullModelName }));
              fetchOllamaModels();
              setPullModelName("");
            } else if (data.total > 0) {
              const pct = Math.round((data.completed / data.total) * 100);
              setPullProgress(`${data.status}: ${pct}%`);
            } else {
              setPullProgress(data.status);
            }
          } catch (e) {}
        }
      }
    } catch (error) {
      toast.error(t("Model downloaden is mislukt"));
    } finally {
      setIsPulling(false);
      setPullProgress("");
    }
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await axios.put(`${API}/settings`, { model, provider, ollama_host: ollamaHost, eigen_adres: eigenAdres, eigen_locatie: eigenLocatie, system_prompt: systemPrompt, claw_allowed_domains: clawAllowedDomains, claw_blocked_domains: clawBlockedDomains, web_access: webAccess, council_ollama_models: councilModels, temperature: temperature === "" ? null : Number(temperature), tabelweg, vault_write: vaultWrite });
      // F3b: alleen een eigenaar stuurt de huisstijl mee; anders weigert de backend
      // met 403 en zou een lid zijn eigen instellingen niet meer kunnen opslaan.
      if (brandMagWijzigen) {
        await axios.put(`${API}/branding`, { app_name: brandName, accent_color: brandAccent, logo_data_uri: brandLogo });
      }
      await refreshBranding();
      onSave();
      onOpenChange(false);
    } catch (error) {
      toast.error(t("Instellingen opslaan is mislukt"));
    } finally {
      setIsSaving(false);
    }
  };

  const currentProvider = PROVIDERS[provider];
  const ProviderIcon = currentProvider?.icon || Cloud;

  const currentProviderKeys = apiKeys.filter(k => k.provider === provider);

  const getModelsForProvider = () => {
    if (provider === "ollama") {
      return ollamaModels.map(m => ({ value: m, label: m }));
    }
    return currentProvider?.models || [];
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] max-h-[85vh] overflow-y-auto" data-testid="settings-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-xl">{t("Instellingen")}</DialogTitle>
          <DialogDescription>{t("Stel je AI-aanbieder en voorkeuren in.")}</DialogDescription>
        </DialogHeader>

        {/* DE TAALSCHAKELAAR (NL/EN-batch A1), boven de tabbladen: hij geldt
            voor de hele app en werkt meteen, zonder de opslaan-knop. */}
        <div className="rounded-md border p-3" data-testid="settings-taal">
          <TaalSchakelaar />
          <p className="mt-2 px-2 text-xs text-muted-foreground">{t("taal.uitleg")}</p>
        </div>

        {isLoading ? (
          <div className="py-8 text-center text-muted-foreground">{t("Laden...")}</div>
        ) : (
          <Tabs key={tab} defaultValue={tab} className="w-full">
            {/* DRIE KOLOMMEN OP SMAL, ZES VANAF `sm`. R57, punt E.
                Franks glastest van 26 augustus 2026 op zijn telefoon: de labels
                liepen over elkaar heen en hij kon niet zien welk tabblad hij
                raakte. Gemeten in een echte browser: negen knoppen in zes
                kolommen geeft op 390 px een kolom van 81 px terwijl "System
                Prompt" er 88 nodig heeft, en `whitespace-nowrap` laat die tekst
                niet afbreken - dus hij loopt over de buurman heen.
                Kortere labels zouden ook passen en raken de vaste vocabulaire
                uit BRAND.md; die zijn daarom afgeraden. Er staat een meting op
                in `meting/opmaak.mjs` die omvalt zodra dit weer op zes staat. */}
            <TabsList className="grid w-full grid-cols-3 sm:grid-cols-6 h-auto">
              <TabsTrigger value="provider">{t("Aanbieder")}</TabsTrigger>
              <TabsTrigger value="keys">{t("Sleutels")}</TabsTrigger>
              <TabsTrigger value="routing">{t("Routering")}</TabsTrigger>
              <TabsTrigger value="prompt">{t("Prompt")}</TabsTrigger>
              <TabsTrigger value="brand">{t("Merk")}</TabsTrigger>
              <TabsTrigger value="phones">{t("Telefoons")}</TabsTrigger>
              <TabsTrigger value="identity">{t("Identiteit")}</TabsTrigger>
              {/* EEN EIGEN TABBLAD EN GEEN REGEL ONDER ADVANCED. Een
                  koppeling met Google geeft toegang tot gegevens weg;
                  dat is geen geavanceerde schakelaar maar een besluit,
                  en het hoort een plek te hebben die je kunt noemen.
                  Met het toetsenbord: Tab naar de tabbladenrij, dan de
                  pijltjes. */}
              <TabsTrigger value="connections">{t("Verbindingen")}</TabsTrigger>
              {/* EEN EIGEN TABBLAD, POST 2 ONDERDEEL 3. Dit is de plek waar
                  Frank een grens openzet, en een grens openzetten laat NovaMund
                  meer doen dan hij standaard mag. Dat is geen geavanceerde
                  instelling maar een besluit met gevolgen, en het hoort niet
                  onderaan een pagina met schuifjes. Het TIENDE tabblad: de rij
                  staat op `grid-cols-3 sm:grid-cols-6`, dus tien past in vier
                  rijen op smal en twee op breed. */}
              <TabsTrigger value="grenzen">{t("Grenzen")}</TabsTrigger>
              {/* F1e: de organisatie die deze installatie is. Het ELFDE
                  tabblad; op smal vier rijen van drie, op breed twee van zes. */}
              <TabsTrigger value="organisatie">{t("Organisatie")}</TabsTrigger>
              {/* G1 (Frank, 18 okt 2026): Billing en Store samen, uit het menu hierheen. */}
              <TabsTrigger value="abonnement">{t("Abonnement")}</TabsTrigger>
              {/* G2: het netwerk, uit het menu hierheen. */}
              <TabsTrigger value="netwerk">{t("Netwerk")}</TabsTrigger>
              {/* L2 (Frank, 19 okt 2026): waar staat wat. */}
              <TabsTrigger value="data">{t("Data")}</TabsTrigger>
              <TabsTrigger value="advanced">{t("Meer")}</TabsTrigger>
            </TabsList>

            <TabsContent value="data" className="space-y-4 py-4">
              <DataOverzicht />
            </TabsContent>

            {/* Its own tab rather than a section of Advanced: this is the only
                place that decides whether a prompt may leave the machine, and
                that does not belong three quarters of the way down a page of
                other settings. */}
            {/* POST 2 ONDERDEEL 3: het schakelbord. Alleen soort 1; wat hier
                niet staat, staat er met zoveel woorden bij en waarom. */}
            <TabsContent value="grenzen" className="space-y-6 py-4">
              <Grenzen />
            </TabsContent>

            {/* G1: het abonnement en daaronder de winkel. "Opwaarderen" scrolt naar
                de winkel in plaats van naar een eigen pagina te gaan. */}
            <TabsContent value="abonnement" className="space-y-8 py-4">
              <AbonnementBlok onUpgrade={() => document.getElementById("instellingen-winkel")?.scrollIntoView({ behavior: "smooth" })} />
              <div id="instellingen-winkel">
                <WinkelBlok />
              </div>
            </TabsContent>

            {/* G2: de netwerkkaart en de peers. Ververst alleen zolang dit tabblad open is. */}
            <TabsContent value="netwerk" className="py-4">
              <NetwerkBlok />
            </TabsContent>

            <TabsContent value="organisatie" className="space-y-6 py-4">
              <Organisatie />
            </TabsContent>

            <TabsContent value="phones" className="space-y-6 py-4">
              <DirectConnection />

              {/* Folded away, and labelled for what it is. Two ways to connect
                  a phone, side by side and looking alike, is how the wrong
                  code gets scanned. */}
              <details className="border-t pt-4" data-testid="old-route">
                <summary className="text-xs text-muted-foreground cursor-pointer select-none">
                  {t("Meer, tijdelijk")}
                </summary>
                <div className="mt-4 space-y-4">
                  <p className="text-[11px] text-corona">
                    {t("De oudere weg naar binnen, alleen bewaard zolang de directe verbinding zich bewijst. Hij heeft Tailscale nodig of een ander adres dat deze machine al bereikt, dus geef hem aan niemand anders. Hij verdwijnt zodra de directe verbinding haar plek heeft verdiend.")}
                  </p>
                  <PairedDevices />
                </div>
              </details>
            </TabsContent>

            {/* Its own tab rather than a line under Phones: pairing a phone
                is about one device reaching this machine, and this is about
                who you are everywhere. */}
            <TabsContent value="identity" className="space-y-4 py-4">
              {/* Closing the dialog is the panel's only reach outside itself:
                  leaving it open over the sign-in screen would hide the very
                  screen it just sent you to. */}
              <SpeaqIdPanel onLeave={() => onOpenChange(false)} />
            </TabsContent>

            <TabsContent value="connections" className="space-y-4 py-4">
              {/* PUNT 4, 11 oktober 2026: HIER, en niet onder Telefoons. Frank
                  zocht het verbindingslog op zijn iPhone onder Verbindingen en
                  vond het niet. Op beide helften, want de interessante helft is
                  de telefoon en een telefoon heeft geen console. */}
              <ConnectionRecord />
              <GoogleConnection />
              <NextcloudConnection />
              <McpServers />
            </TabsContent>

            <TabsContent value="routing" className="space-y-4 py-4">
              <RoutingPolicyPanel ollamaModels={ollamaModels} />
            </TabsContent>

            <TabsContent value="provider" className="space-y-4 py-4">
              <div className="space-y-2">
                <Label>{t("AI-aanbieder")}</Label>
                <Select value={provider} onValueChange={(val) => {
                  setProvider(val);
                  const newModels = PROVIDERS[val]?.models;
                  if (newModels?.length > 0) setModel(newModels[0].value);
                }}>
                  <SelectTrigger data-testid="provider-select">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {gegroepeerd(PROVIDERS, eigenLocatie).map((groep) => (
                      <SelectGroup key={groep.plek} data-testid={`aanbieders-${groep.plek}`}>
                        <SelectLabel>{t(groep.tekst)}</SelectLabel>
                        {groep.items.map(([key, prov]) => {
                          const Icon = prov.icon;
                          return (
                            <SelectItem key={key} value={key}>
                              <div className="flex items-center gap-2">
                                <Icon className="h-4 w-4" />
                                {prov.name}
                              </div>
                            </SelectItem>
                          );
                        })}
                      </SelectGroup>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              {currentProvider?.requiresKey && (
                <div className="space-y-2">
                  <Label>{t("API-sleutel")}</Label>
                  {currentProviderKeys.length > 0 ? (
                    <div className="text-sm text-muted-foreground bg-muted rounded-lg p-3 flex items-center gap-2">
                      <Key className="h-4 w-4" />
                      {currentProviderKeys[0].key_masked}
                    </div>
                  ) : (
                    <div className="text-sm text-muted-foreground bg-muted rounded-lg p-3">
                      {t("Geen sleutel ingesteld. Voeg er een toe onder Sleutels.")}
                    </div>
                  )}
                  {currentProvider.keyUrl && <p className="text-xs text-muted-foreground">
                    {t("Sleutel ophalen bij")}{" "}
                    <a href={currentProvider.keyUrl} target="_blank" rel="noopener noreferrer" className="text-[hsl(var(--accent))] hover:underline inline-flex items-center gap-1">
                      {currentProvider.name} <ExternalLink className="h-3 w-3" />
                    </a>
                  </p>}
                </div>
              )}

              {provider === "eigen" && (
                <div className="space-y-2" data-testid="eigen-aanbieder">
                  <Label>{t("Adres van de aanbieder")}</Label>
                  <Input value={eigenAdres} onChange={(e) => setEigenAdres(e.target.value)}
                         placeholder="https://.../v1" data-testid="eigen-adres" />
                  <Label>{t("Waar staat deze aanbieder?")}</Label>
                  <Select value={eigenLocatie || "onbekend"} onValueChange={(v) => setEigenLocatie(v === "onbekend" ? "" : v)}>
                    <SelectTrigger data-testid="eigen-locatie"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="onbekend">{t("Locatie onbekend")}</SelectItem>
                      <SelectItem value="eu">{t("Binnen de EU")}</SelectItem>
                      <SelectItem value="buiten_eu">{t("Buiten de EU")}</SelectItem>
                    </SelectContent>
                  </Select>
                  <p className="text-xs text-muted-foreground">
                    {t("Alleen https. De sleutel zet je onder Sleutels. Tot je de plek kiest, staat hij als locatie onbekend.")}
                  </p>
                </div>
              )}

              {provider === "ollama" && (
                <div className="space-y-2">
                  <Label>{t("Ollama-adres")}</Label>
                  <div className="flex gap-2">
                    <Input
                      value={ollamaHost}
                      onChange={(e) => setOllamaHost(e.target.value)}
                      placeholder="http://localhost:11434"
                    />
                    <Button variant="outline" size="icon" onClick={fetchOllamaModels} disabled={isLoadingOllama}>
                      <RefreshCw className={`h-4 w-4 ${isLoadingOllama ? 'animate-spin' : ''}`} />
                    </Button>
                  </div>
                </div>
              )}

              <div className="space-y-2">
                <Label>{t("Model")}</Label>
                {currentProvider?.vrijModel ? (
                  <Input value={model} onChange={(e) => setModel(e.target.value)} placeholder={t("De modelnaam zoals de aanbieder hem noemt")}
                         data-testid="eigen-model" />
                ) : provider === "ollama" && ollamaModels.length === 0 ? (
                  <div className="text-sm text-muted-foreground bg-muted rounded-lg p-3">
                    {t("Geen modellen gevonden. Download er hieronder een, of draai:")} <code className="bg-background px-1 rounded">ollama pull llama3.2</code>
                  </div>
                ) : (
                  <Select value={model} onValueChange={setModel}>
                    <SelectTrigger data-testid="model-select">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {getModelsForProvider().map((m) => (
                        <SelectItem key={m.value} value={m.value}>{m.label}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                )}
              </div>

              {/* LC1: het model voor het scherm Code, los van het chatmodel. */}
              {provider === "ollama" && (
                <div className="pt-2 border-t space-y-4">
                  {/* MK1 (3 nov): deze Mac, per lokaal model of het past, en het lokale advies. */}
                  <MachineAdvies />
                  {/* MK5 (3 nov): het model per rol en de terugval, alleen lokaal. */}
                  <ModelRollen />
                  <CodeModelKeuze />
                  {/* LC2: per model hoeveel codeopdrachten echt lukken. */}
                  <CodeMeetset />
                </div>
              )}

              {provider === "ollama" && (
                <div className="space-y-2 pt-2 border-t">
                  <Label>{t("Nieuw model downloaden")}</Label>
                  <div className="flex gap-2">
                    <Input
                      value={pullModelName}
                      onChange={(e) => setPullModelName(e.target.value)}
                      placeholder={t("bijv. llama3.2, mistral, codellama")}
                      disabled={isPulling}
                    />
                    <Button onClick={handlePullModel} disabled={isPulling || !pullModelName.trim()}>
                      <Download className="h-4 w-4 mr-2" />
                      {t("Downloaden")}
                    </Button>
                  </div>
                  {pullProgress && <p className="text-xs text-muted-foreground">{pullProgress}</p>}
                </div>
              )}
            </TabsContent>

            <TabsContent value="keys" className="space-y-4 py-4">
              <p className="text-sm text-muted-foreground">{t("Bewaar API-sleutels per aanbieder. Ze worden versleuteld opgeslagen.")}</p>

              <div className="space-y-3">
                {Object.entries(PROVIDERS).filter(([, p]) => p.requiresKey).map(([key, prov]) => {
                  const keysForProvider = apiKeys.filter(k => k.provider === key);
                  return (
                    <div key={key} className="bg-muted rounded-lg p-3 space-y-2">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <prov.icon className="h-4 w-4" />
                          <span className="text-sm font-medium">{prov.name}</span>
                        </div>
                        {keysForProvider.length > 0 && (
                          <span className="text-xs text-muted-foreground">{t("{n} sleutel(s)", { n: keysForProvider.length })}</span>
                        )}
                      </div>

                      {keysForProvider.map((k) => (
                        <div key={k.id} className="flex items-center justify-between bg-background rounded px-2 py-1">
                          <span className="text-xs font-mono">{k.key_masked}</span>
                          <Button variant="ghost" size="icon" className="h-6 w-6 text-destructive" onClick={() => handleDeleteKey(k.id)}>
                            <Trash2 className="h-3 w-3" />
                          </Button>
                        </div>
                      ))}

                      <Button variant="outline" size="sm" className="w-full" onClick={() => { setProvider(key); setNewKeyValue(""); setShowNewKey(true); }}>
                        <Plus className="h-3 w-3 mr-2" />
                        {t("Sleutel toevoegen")}
                      </Button>
                    </div>
                  );
                })}
              </div>

              {showNewKey && (
                <div className="border rounded-lg p-4 space-y-3">
                  <Label>{t("Nieuwe sleutel voor {naam}", { naam: PROVIDERS[provider]?.name })}</Label>
                  <div className="relative">
                    <Input
                      type={showNewKey ? "text" : "password"}
                      value={newKeyValue}
                      onChange={(e) => setNewKeyValue(e.target.value)}
                      placeholder={`API-sleutel voor ${PROVIDERS[provider]?.name}`}
                      className="pr-10"
                    />
                    <Button type="button" variant="ghost" size="icon" className="absolute right-0 top-0 h-full px-3" onClick={() => setShowNewKey(!showNewKey)}>
                      {showNewKey ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                    </Button>
                  </div>
                  <div className="flex gap-2">
                    <Button variant="outline" size="sm" onClick={() => { setShowNewKey(false); setNewKeyValue(""); }}>
                      {t("Annuleren")}
                    </Button>
                    <Button size="sm" onClick={handleAddKey} disabled={isAddingKey || !newKeyValue.trim()}>
                      {isAddingKey ? t("Opslaan...") : t("Sleutel opslaan")}
                    </Button>
                  </div>
                </div>
              )}
            </TabsContent>

            <TabsContent value="prompt" className="space-y-4 py-4">
              <div className="space-y-2">
                <Label>{t("Extra instructies")}</Label>
                <Textarea
                  value={systemPrompt}
                  onChange={(e) => setSystemPrompt(e.target.value)}
                  placeholder={t("Leeg laten kan. Wat hier staat, komt na de persona uit Merk.")}
                  className="min-h-[200px]"
                  data-testid="system-prompt-input"
                />
                <p className="text-xs text-muted-foreground">
                  {t("De persona staat in Instellingen > Merk. Wat hier staat, komt erna als extra instructie; de vaste regels van NovaMund wegen zwaarder.")}
                </p>
              </div>
              <Button
                variant="outline"
                size="sm"
                onClick={() => setSystemPrompt(DEFAULT_SYSTEM_PROMPT)}
              >
                {t("Terug naar standaard")}
              </Button>
            </TabsContent>

            <TabsContent value="brand" className="space-y-4 py-4">
              <p className="text-xs text-muted-foreground">{t("Jouw merk, jouw wereld. Deze instellingen geven de app jouw stijl en sturen hoe de AI schrijft.")}</p>
              <p className="text-xs text-muted-foreground" data-testid="brand-voor-iedereen">
                {t("De huisstijl geldt voor de hele organisatie. Het NovaMund-beeldmerk blijft altijd staan; je eigen logo komt ernaast. Lege velden vallen terug op de standaard van NovaMund.")}
              </p>
              {!brandMagWijzigen && (
                <p className="text-xs font-medium" data-testid="brand-alleen-lezen">
                  {t("Alleen een eigenaar kan de huisstijl wijzigen.")}
                </p>
              )}
              <fieldset disabled={!brandMagWijzigen} className="space-y-4" data-testid="brand-velden">
              <div className="space-y-2">
                <Label htmlFor="brand-name">{t("Naam van de organisatie")}</Label>
                <Input id="brand-name" value={brandName} onChange={(e) => setBrandName(e.target.value)} placeholder={t("bijv. Plexaris")} />
              </div>
              <div className="space-y-2">
                <Label htmlFor="brand-accent">{t("Accentkleur")}</Label>
                <div className="flex items-center gap-2">
                  <input
                    type="color"
                    value={/^#[0-9a-fA-F]{6}$/.test(brandAccent) ? brandAccent : "#FF6B35"}
                    onChange={(e) => setBrandAccent(e.target.value)}
                    className="h-9 w-12 rounded cursor-pointer border bg-transparent"
                    aria-label={t("Kies een accentkleur")}
                  />
                  <Input id="brand-accent" value={brandAccent} onChange={(e) => setBrandAccent(e.target.value)} placeholder={t("#FF6B35 (leeg = standaard)")} className="flex-1" />
                </div>
              </div>
              <div className="space-y-2">
                <Label>{t("Logo")}</Label>
                <div className="flex items-center gap-3">
                  {brandLogo ? (
                    <img src={brandLogo} alt={t("Merklogo")} className="w-10 h-10 rounded-lg object-contain border" />
                  ) : (
                    <div className="w-10 h-10 rounded-lg border flex items-center justify-center text-xs text-muted-foreground">{t("geen")}</div>
                  )}
                  <Button type="button" variant="outline" size="sm" onClick={() => document.getElementById("brand-logo-input")?.click()}>{t("Uploaden")}</Button>
                  {brandLogo && (
                    <Button type="button" variant="ghost" size="sm" onClick={() => setBrandLogo("")}>{t("Verwijderen")}</Button>
                  )}
                  <input id="brand-logo-input" type="file" accept="image/png,image/jpeg,image/svg+xml,image/webp" className="hidden" onChange={handleLogoFile} />
                </div>
                <p className="text-xs text-muted-foreground">{t("Blijft op je machine, lokaal bewaard bij je werkruimte.")}</p>
              </div>
              </fieldset>
              {/* POST P: Toon en Woordkeus zijn opgegaan in het blok Persona, onderaan. */}
              <PersonaBlok rol={brandRol} />
            </TabsContent>

            <TabsContent value="advanced" className="space-y-4 py-4">
              {/* A pointer, not a second place to do it. Everything remembered
                  lives on its own screen; hiding it inside a settings tab is
                  how a promise about forgetting becomes hard to find. */}
              <div className="border rounded-lg p-4 space-y-2">
                <h4 className="font-medium text-sm">{t("Geheugen")}</h4>
                <p className="text-xs text-muted-foreground">
                  {t("Wat Novamund over jou en je werk heeft geleerd, alleen op deze machine bewaard. Je kunt elke regel lezen en alles verwijderen.")}
                </p>
                <Button
                  variant="outline"
                  size="sm"
                  data-testid="settings-memory-link"
                  onClick={() => { onOpenChange(false); navigate("/memory"); }}
                >
                  {t("Geheugen openen")}
                </Button>
              </div>

              {/* GLASRONDE 0.9.238 (Frank 3 nov), bevinding 2: het gespreksverslag uit Fathom (aan/uit, deelgrootte,
                  tijdslimiet) staat hier onder Meer, niet meer onder Aanbieder. Altijd zichtbaar: de server weigert
                  zelf een verslag op een cloudmodel. */}
              <div className="border rounded-lg p-4" data-testid="meer-verslag">
                <VerslagInstelling />
              </div>

              <div className="bg-muted rounded-lg p-4 space-y-3">
                <div className="flex items-center gap-2">
                  <ProviderIcon className="h-5 w-5 text-[hsl(var(--accent))]" />
                  <h4 className="font-medium">{currentProvider?.name}</h4>
                </div>
                
                {provider === "openrouter" && (
                  <ul className="text-sm text-muted-foreground list-disc pl-4 space-y-1">
                    <li>{t("Toegang tot Claude, GPT-4, Llama en meer")}</li>
                    <li>{t("Betaal per token, geen abonnement")}</li>
                  </ul>
                )}
                
                {provider === "ollama" && (
                  <ul className="text-sm text-muted-foreground list-disc pl-4 space-y-1">
                    <li>{t("100% privé: je gegevens verlaten je apparaat niet")}</li>
                    <li>{t("Geen API-kosten, werkt zonder internet")}</li>
                    <li>{t("Werkt het best met een eigen GPU")}</li>
                  </ul>
                )}

                {(provider === "anthropic" || provider === "openai" || provider === "gemini") && (
                  <ul className="text-sm text-muted-foreground list-disc pl-4 space-y-1">
                    <li>{t("Snelle, betrouwbare AI in de cloud")}</li>
                    <li>{t("Vraagt een API-sleutel en internet")}</li>
                  </ul>
                )}
              </div>

              <div className="border rounded-lg p-4 space-y-3">
                <h4 className="font-medium text-sm">{t("LLM-raad: lokale leden")}</h4>
                <p className="text-xs text-muted-foreground">
                  {t("Kies de lokale modellen die in de raad zitten. Er zijn er minstens twee nodig voordat hij kan draaien. Vink niets aan om alleen het model te gebruiken waarmee je chat. Elk lid is een aparte aanroep, dus meer leden betekent langer wachten.")}
                </p>
                {ollamaModels.length === 0 ? (
                  <p className="text-xs text-muted-foreground">
                    {t("Geen lokale modellen gevonden. Ollama moet draaien om deze lijst te vullen.")}
                  </p>
                ) : (
                  <div className="space-y-1 max-h-48 overflow-y-auto" data-testid="council-model-list">
                    {ollamaModels.map((m) => (
                      <label key={m} className="flex items-center gap-2 text-sm cursor-pointer py-0.5">
                        <input
                          type="checkbox"
                          checked={councilModels.includes(m)}
                          onChange={() => setCouncilModels(prev =>
                            prev.includes(m) ? prev.filter(x => x !== m) : [...prev, m]
                          )}
                          className="h-4 w-4 rounded border-input accent-[hsl(var(--accent))]"
                        />
                        <span className="font-mono text-xs">{m}</span>
                      </label>
                    ))}
                  </div>
                )}
                {councilModels.length === 1 && (
                  <p className="text-xs text-muted-foreground">
                    {t("Een model gekozen. De raad heeft er minstens twee nodig, of een API-sleutel van een andere aanbieder.")}
                  </p>
                )}
                {councilMaxMembers > 0 && councilModels.length > councilMaxMembers && (
                  <p className="text-xs text-corona dark:text-corona" data-testid="council-cap-notice">
                    {t("Een raad heeft {n} leden. Alleen de eerste {n} hiervan doen mee, en een aanbieder waarvoor je een API-sleutel hebt, telt eerst.", { n: councilMaxMembers })}
                  </p>
                )}
              </div>

              {/* One switch, and it sits above the domain lists on purpose:
                  this decides whether the assistant may reach the internet at
                  all, and those decide where it may go once it may go
                  anywhere. With this off there is nothing for them to narrow. */}
              <div className="border rounded-lg p-4 space-y-3" data-testid="web-access-block">
                <div className="flex items-start justify-between gap-4">
                  <div className="space-y-1">
                    <h4 className="font-medium text-sm">{t("Webtoegang")}</h4>
                    <p className="text-xs text-muted-foreground">
                      {t("Of Novamund een webpagina voor je mag ophalen. Standaard uit.")}
                    </p>
                  </div>
                  {/* Measured at 390 on 28 July: the switch draws 20 points
                      tall, under the 44 this app holds itself to on a phone.
                      The hit area is grown with an invisible box around it
                      rather than by making the switch bigger, because the
                      thumb's travel is tied to the drawn size and stretching
                      it leaves the dot short of the end. */}
                  <Switch
                    checked={webAccess}
                    onCheckedChange={setWebAccess}
                    aria-label={t("Webtoegang")}
                    data-testid="web-access-switch"
                    className="relative flex-shrink-0 after:absolute after:-inset-3 after:content-['']"
                  />
                </div>
                <p className="text-xs text-muted-foreground">
                  {webAccess
                    ? t("Aan. De assistent kan een pagina lezen die jij noemt of die hij vindt, en elk adres dat hij ophaalt staat bij dat antwoord onder Laat je werk zien.")
                    : t("Uit. Het gereedschap dat het internet op gaat wordt het model helemaal niet aangeboden, dus het kan het niet per ongeluk gebruiken en ook niet doen alsof: gevraagd naar een website zegt het dat het dat niet kan opzoeken.")}
                </p>
              </div>

              {/* DE TABELWEG (R40), Franks terugvalschakelaar van 23 augustus 2026.
                  Zijn eis was letterlijk "uit kunnen zetten ZONDER NIEUWE BUILD",
                  en dat is de reden dat dit een schakelaar op het scherm is en
                  geen omgevingsvariabele: op het moment dat het misgaat is er
                  geen bouwrit meer. */}
              <div className="border rounded-lg p-4 space-y-3" data-testid="tabelweg-block">
                <div className="flex items-center justify-between gap-3">
                  <div className="space-y-1">
                    <h4 className="font-medium text-sm">{t("Antwoord uit een tabelrij")}</h4>
                    <p className="text-xs text-muted-foreground">
                      {t("Voor vragen als \u201choeveel uur op DOQENT\u201d. Standaard aan.")}
                    </p>
                  </div>
                  {/* Dezelfde vergrote tikzone als de webschakelaar hierboven,
                      en om dezelfde reden: 20 punten getekend, 44 nodig op een
                      telefoon. */}
                  <Switch
                    checked={tabelweg}
                    onCheckedChange={setTabelweg}
                    aria-label={t("Antwoord uit een tabelrij")}
                    data-testid="tabelweg-switch"
                    className="relative flex-shrink-0 after:absolute after:-inset-3 after:content-['']"
                  />
                </div>
                <p className="text-xs text-muted-foreground">
                  {tabelweg
                    ? t("Aan. Vraagt een vraag om een hoeveelheid, dan krijgt het model de hele tabel, en de rij waar het getal uit komt staat onder het antwoord, zodat je het kunt nakijken.")
                    : t("Uit. Antwoorden komen alleen uit de gevonden passages. Een getal in een tabel die de zoekactie niet bereikte wordt niet gevonden, en er staat geen rij bij.")}
                </p>
              </div>

              {/* R19: terugschrijven naar het bestand. Frank, 26 augustus 2026.

                  STAAT HIER, DIRECT ONDER DE TABELWEG, en dat is een keuze met
                  een reden: dit is het tabblad waar de schakelaars staan die
                  gedrag omzetten, en Franks eis was hem te kunnen VINDEN zonder
                  zoeken. Toetsenbordweg: Tab naar de tabbladenrij, pijltjes
                  naar Advanced, Tab naar binnen, Spatie op de schakelaar.

                  De vergrote tikzone is dezelfde als hierboven en om dezelfde
                  reden: 20 punten getekend, 44 nodig op een telefoon. */}
              {/* Basismap zien en wijzigen (Frank, 18 okt 2026, glasronde 0.9.169). */}
              <BasismapBlok />
              {/* L2 (Frank, 19 okt 2026): Dropbox als opslag, bij de basismap. */}
              <div className="border rounded-lg p-4">
                <DropboxSchakelaar plek="basismap" />
              </div>
              {/* L3b (Frank, 19 okt 2026): versleutelde back-up met herstel-test, alleen een eigenaar. */}
              <BackupBlok />
              {/* Glasronde 0.9.178 (Frank, 19 okt 2026): de sleutel die de back-up nodig heeft. */}
              <PqcBlok />
              {/* L4 (Frank, 19 okt 2026): export in open formaat. */}
              <ExportBlok />
              {/* GL215 S3: een dossier nakijken tegen zijn manifest. */}
              <DossierControle />
              {/* L5 (Frank, 19 okt 2026): de vluchtrecorder per periode. */}
              <VluchtrecorderBlok />
              {/* CC7 (besluit Frank 24 okt 2026): spoor, handelingsrij en koppelingen samen, alleen lezen. */}
              <LogboekBlok />

              <div className="border rounded-lg p-4 space-y-3" data-testid="vault-write-block">
                <div className="flex items-center justify-between gap-3">
                  <div className="space-y-1">
                    <h4 className="font-medium text-sm">{t("Wijzigingen terugschrijven naar het bestand")}</h4>
                    <p className="text-xs text-muted-foreground">
                      {t("Hiermee bewerk je een document en schrijf je het terug naar het markdownbestand waar het vandaan kwam. Standaard uit.")}
                    </p>
                  </div>
                  <Switch
                    checked={vaultWrite}
                    onCheckedChange={setVaultWrite}
                    aria-label={t("Wijzigingen terugschrijven naar het bestand")}
                    data-testid="vault-write-switch"
                    className="relative flex-shrink-0 after:absolute after:-inset-3 after:content-['']"
                  />
                </div>
                <p className="text-xs text-muted-foreground">
                  {vaultWrite
                    ? t("Aan. Documenten uit een gekoppelde map krijgen een knop Bewerken. Opslaan overschrijft het .md-bestand op schijf, en dat is hier niet terug te draaien. Alleen markdownbestanden kunnen worden geschreven; een PDF- of Word-bestand wordt geweigerd, omdat er alleen de uitgelezen tekst is geindexeerd en terugschrijven het origineel zou vervangen.")
                    : t("Uit. Documenten openen alleen om te lezen, en NovaMund raakt geen bestand op schijf aan.")}
                </p>
                {/* H8 (Frank, 18 okt 2026): een regel per soort. */}
                <SchrijfSoorten />
              </div>

              {/* Hoe warm het model mag trekken (R34).
                  DE BELOFTE HIERONDER IS TWEE KEER SMALLER GEMAAKT, EN BEIDE
                  KEREN OP EEN METING. Er stond eerst dat hetzelfde antwoord
                  terugkomt zolang de app draait. Dat is onwaar op twee
                  manieren, en allebei zijn ze gemeten op 22 augustus 2026:

                    over een HERSTART heen  identieke prompt, temperatuur en
                                            seed gaven na een herlading van het
                                            model een ander antwoord
                    over een MINUUTGRENS    het tijdblok draagt `The time is
                                            16:37.`, dus de prompt verandert
                                            elke minuut. Gemeten: binnen 16:37
                                            twee keer hetzelfde antwoord, op
                                            16:38 een ander van 698 in plaats
                                            van 185 tekens

                  Daarom staat er nu "within the same minute" en niet "while
                  the app keeps running". Een belofte die de gebruiker binnen
                  een minuut ziet breken is erger dan geen belofte.
                  SINDS W9 (Frank 22 oktober 2026, keuze b) rondt het tijdblok af
                  op het kwartier, behalve bij een klokvraag; de belofte is dus
                  het kwartier. Gemeten: om 16:31 en 16:44 drie keer hetzelfde.
                  En het reproduceerbare deel komt van de SEED en niet van dit
                  getal: temperatuur 0 en 0,2 gaven met dezelfde seed exact
                  dezelfde spreiding. Dit veld gaat dus over stijl. */}
              <div className="border rounded-lg p-4 space-y-3" data-testid="temperature-block">
                <div className="space-y-1">
                  <h4 className="font-medium text-sm">{t("Temperatuur")}</h4>
                  <p className="text-xs text-muted-foreground">
                    {t("Hoe vrij het model zijn woorden kiest. Laat leeg voor de standaard van {n}, die antwoorden stabiel genoeg houdt om te vergelijken. Zet hem hoger voor schrijfwerk.", { n: defaultTemperature })}
                  </p>
                </div>
                <Input
                  type="number"
                  min="0"
                  max="2"
                  step="0.1"
                  value={temperature}
                  onChange={(e) => setTemperature(e.target.value)}
                  placeholder={t("standaard ({n})", { n: defaultTemperature })}
                  aria-label={t("Temperatuur")}
                  data-testid="temperature-input"
                />
                <p className="text-xs text-muted-foreground">
                  {t("Binnen hetzelfde kwartier geeft dezelfde vraag hetzelfde antwoord; vraag je hoe laat het is, dan binnen dezelfde minuut. Daarna kan het verschillen, omdat elk antwoord de huidige tijd meekrijgt. Ook na een herstart kan het verschillen.")}
                </p>
              </div>

              <div className="border rounded-lg p-4 space-y-3">
                <h4 className="font-medium text-sm">{t("CLAW-browserveiligheid")}</h4>
                {/* Both lists are optional. The switch above is the gate; these
                    are for somebody who wants to narrow what is already on.
                    There used to be a warning here about an empty allowed list
                    meaning nowhere, and it is gone with the rule it explained. */}
                <p className="text-xs text-muted-foreground">
                  {t("Waar hij heen mag als webtoegang aan staat. Gescheiden door komma's, en allebei optioneel: de schakelaar hierboven beslist of de assistent het internet uberhaupt bereikt.")}
                </p>
                <div className="space-y-2">
                  <Label htmlFor="claw-allowed">
                    {t("Toegestane domeinen (leeg = alle sites; vul dit alleen in als je wilt beperken waar hij heen mag)")}
                  </Label>
                  <Textarea
                    id="claw-allowed"
                    value={clawAllowedDomains}
                    onChange={(e) => setClawAllowedDomains(e.target.value)}
                    placeholder={t("bijv. github.com, wikipedia.org")}
                    className="min-h-[60px] text-sm"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="claw-blocked">{t("Geblokkeerde domeinen")}</Label>
                  <Textarea
                    id="claw-blocked"
                    value={clawBlockedDomains}
                    onChange={(e) => setClawBlockedDomains(e.target.value)}
                    placeholder={t("bijv. login.example.com, mail.google.com")}
                    className="min-h-[60px] text-sm"
                  />
                </div>
              </div>

              <div className="text-xs text-muted-foreground space-y-1">
                <p><strong>{t("Sneltoetsen:")}</strong></p>
                <p><kbd className="px-1 py-0.5 bg-muted rounded">⌘K</kbd> {t("Zoeken •")} <kbd className="px-1 py-0.5 bg-muted rounded">⌘N</kbd> {t("Nieuwe chat •")} <kbd className="px-1 py-0.5 bg-muted rounded">⌘,</kbd> {t("Instellingen •")} <kbd className="px-1 py-0.5 bg-muted rounded">⌘B</kbd> {t("Zijbalk tonen of verbergen")}</p>
              </div>

              {/* L6 (Frank, 19 okt 2026): blok Over met de versie en de SBOM. De versie
                  blijft de twee helften apart tonen, want een telefoon laadt zijn
                  scherm van connect en tunnelt naar de Mac: dat kunnen twee bouwen zijn. */}
              <OverBlok />
            </TabsContent>
          </Tabs>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>{t("Annuleren")}</Button>
          <Button onClick={handleSave} disabled={isSaving} data-testid="save-settings-btn">
            {isSaving ? t("Opslaan...") : t("Instellingen opslaan")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
